"use client";

import Link from "next/link";
import CommonImage from "../../image/CommonImage";
import { FaAngleRight } from "react-icons/fa6";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { usePathname } from "next/navigation";
import Image from "next/image";

export default function StudentTopNav({ isOpen, toggleMenu, logoutHandler }) {
  const menuRef = useRef(null);
  const userInfo = useSelector((state) => state.user.userInfo);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       toggleMenu(false);
  //     }
  //   };

  //   if (isOpen) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [isOpen, toggleMenu]);

  const pathname = usePathname();
  const isStudentRoute = pathname.startsWith("/student");

  const linkHref = isStudentRoute ? "/" : "/student/dashboard";
  const linkText = isStudentRoute ? "ওয়েবসাইটে যাও" : "ড্যাশবোর্ডে যাও";

  return (
    <div ref={menuRef} className="relative">
      <button
        className="student-profile cursor-pointer flex"
        onClick={toggleMenu}
      >
        <Image
          src={
            userInfo?.student?.profile_url ??
            "/images/student-dashboard/student-profile-mobile.avif"
          }
          className="profile-image cursor-pointer"
          alt="Profile"
          width={100}
          height={100}
        />
      </button>

      {isOpen && (
        <div
          className="student-profile-dropdown-menu"
          onClick={() => toggleMenu()}
        >
          <Link href={linkHref} className="dpdw-item">
            <div className="item-content">
              <div className="icon">
                <CommonImage
                  src="/images/student-dashboard/go-to-web.avif"
                  className="dropdown-icon"
                  alt="icon"
                />
              </div>
              <span className="text">{linkText}</span>
            </div>
            <FaAngleRight className="arrow-icon" />
          </Link>

          <Link href="/student/profile" className="dpdw-item">
            <div className="item-content">
              <div className="icon">
                <CommonImage
                  src={"/images/student-dashboard/setting.avif"}
                  className="dropdown-icon"
                  alt={"icon"}
                />
              </div>
              <span className="text">সেটিংস</span>
            </div>
            <FaAngleRight className="arrow-icon" />
          </Link>

          <Link
            href="#"
            className="dpdw-item"
            onClick={(e) => {
              e.preventDefault();
              logoutHandler();
            }}
          >
            <div className="item-content">
              <div className="icon">
                <CommonImage
                  src={"/images/student-dashboard/logout.avif"}
                  className="dropdown-icon"
                  alt={"icon"}
                />
              </div>
              <span className="text">লগআউট</span>
            </div>
            <FaAngleRight className="arrow-icon" />
          </Link>
        </div>
      )}
    </div>
  );
}
